import React, { useEffect, useState } from "react";
import styled from "styled-components";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import galleryImagesArray from "../../galleryImages.js";
import videos from "../../VideoData.js";
import { Link } from "react-router-dom";

const GalleryPageArea = () => {
  const [galleryItems, setGalleryItems] = useState([]);
  const [selectedImageIndex, setSelectedImageIndex] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [vdos, setVdos] = useState([]);
  const [activeTab, setActiveTab] = useState("Images");
  const tabs = ["Images", "Videos"];
  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  useEffect(() => {
    setGalleryItems(galleryImagesArray);
  }, [setGalleryItems]);

  useEffect(() => {
    setVdos(videos);
  }, [setVdos]);

  const openModal = (index) => {
    setSelectedImageIndex(index);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setSelectedImageIndex(0);
    setIsModalOpen(false);
  };

  const CustomNextArrow = ({ onClick }) => (
    <button className="custom-arrow next-arrow" onClick={onClick}>
      &#8250;
    </button>
  );

  const CustomPrevArrow = ({ onClick }) => (
    <button className="custom-arrow prev-arrow" onClick={onClick}>
      &#8249;
    </button>
  );

  const sliderSettings = {
    initialSlide: selectedImageIndex,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    nextArrow: <CustomNextArrow />,
    prevArrow: <CustomPrevArrow />,
  };

  return (
    <Wrapper>
      <div className="room-area inner">
        <div className="container">
          <div className="row">
            <div className="col-md-12 text-center">
              <div className="section-title center inner">
                <div className="section-thumb">
                  <img
                    src="/assets/images/home-1/section-shape111.png"
                    alt=""
                  />
                </div>
                <h1>Resort's gallery</h1>
              
              </div>
            </div>
          </div>

          <div className="food-menu-area py-0 mt-0 rounded">
            <div className="container pt-5">
              <div className="row">
                <div className="col-md-12">
                  <div className="food-tab-menu d-flex justify-content-center align-items-center">
                    <ul
                      className="nav nav-pills mb-3 d-flex justify-content-left align-items-center gap-2 uull row_horizon"
                      role="tablist"
                    >
                      {tabs.map((tab) => (
                        <li key={tab} className="nav-item" role="presentation">
                          <button
                            type="button"
                            className={`nav-link ${
                              activeTab === tab ? "active" : ""
                            }`}
                            onClick={() => handleTabChange(tab)}
                            style={{
                              textTransform: "uppercase",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {tab}
                          </button>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {activeTab === "Images" && (
            <div className="designs">
              {galleryItems &&
                galleryItems.map((img, index) => (
                  <div
                    className="coll"
                    key={index}
                    onClick={() => openModal(index)}
                  >
                    <img src={img.image} alt={`Design ${index + 1}`} />
                  </div>
                ))}
            </div>
          )}

          {activeTab === "Videos" && (
            <div className="designs">
              {vdos &&
                vdos.map((img, index) => (
                  <div className="coll video-container" key={index}>
                    <img src={img.image} alt={`Design ${index + 1}`} />

                    <div className="video-overlay">
                      <Link
                        className="call-do-action-video"
                        aria-label="Play video"
                        to={img.link}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <i className="bi bi-play"></i>
                      </Link>
                    </div>
                  </div>
                ))}
            </div>
          )}
        </div>
      </div>

      {isModalOpen && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="close-modal" onClick={closeModal}>
              &times;
            </button>
            {galleryItems.length > 0 && (
              <Slider {...sliderSettings}>
                {galleryItems &&
                  galleryItems.map((img, index) => (
                    <div key={index}>
                      <img
                        src={img.image}
                        alt={`Selected Design ${index + 1}`}
                        className="modal-image"
                        style={{ width: "100%" }}
                      />
                    </div>
                  ))}
              </Slider>
            )}
          </div>
        </div>
      )}
    </Wrapper>
  );
};

const Wrapper = styled.section`
  .designs {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
  }

  .coll {
    width: calc(33.33% - 10px);
    margin-bottom: 20px;
    cursor: pointer;
    overflow: hidden;
    border-radius: 4px;

    img {
      width: 100%;
      height: 320px !important;
      object-fit: cover;
      transition: transform 0.5s cubic-bezier(0.25, 0.1, 0.25, 1);
    }

    &:hover img {
      transform: scale(1.1);
    }
  }

  /* ====== modal ====== */
  .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.8);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
  }

  .modal-content {
    position: relative;
    border: none;
    background-color: transparent;
  }

  .modal-image {
    max-width: 100% !important;
    height: 500px !important;
    display: block;
    border-radius: 4px;
  }

  .close-modal {
    position: fixed;
    top: 20px;
    right: 20px;
    background: transparent;
    border: none;
    font-size: 3rem;
    color: #fff;
    cursor: pointer;
    z-index: 1100;
    line-height: 1;
  }

  .custom-arrow {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    background: rgba(255, 255, 255, 0.8);
    border: none;
    padding: 2px 10px;
    border-radius: 10%;
    font-size: 1.5rem;
    cursor: pointer;
    z-index: 1100;
  }

  .next-arrow {
    right: -50px;
    /* background-color: #fff !important; */
  }

  .prev-arrow {
    left: -50px;
    /* background-color: #fff !important; */
  }

  /* ==== videos ===== */
  .video-container {
    position: relative;
    display: inline-block;
  }

  .video-container img {
    display: block;
    width: 100%;
    height: auto;
  }

  .video-overlay {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 1;
  }

  .video-vemo-icon {
    background-color: #c19d68;
    border: none;
    border-radius: 50%;
    padding: 15px;
    color: white;
    font-size: 24px;
    cursor: pointer;
    position: relative;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    width: 50px;
    height: 50px;
  }

  .call-do-action-video i::after {
    position: absolute;
    content: "";
    background: none !important;

    animation: ripple 1.6s ease-out infinite;
    z-index: -1;
  }

  @keyframes ripple {
    0% {
      transform: scale(1);
      opacity: 1;
    }
    100% {
      transform: scale(2.5);
      opacity: 0;
    }
  }

  @media screen and (max-width: 1024px) {
    .coll {
      width: calc(50% - 10px);
    }
  }

  @media screen and (max-width: 768px) {
    .coll {
      width: calc(50% - 10px);
    }
    .modal-content {
      width: 60% !important;
    }
    .modal-image {
      /* max-width: 100%; */
      height: 400px !important;
    }
  }

  @media screen and (max-width: 480px) {
    .coll {
      width: 100%;
    }
  }
  @media screen and (max-width: 425px) {
    .coll {
      width: 100%;
    }
    .modal-image {
      /* max-width: 100%; */
      height: 300px !important;
    }
  }

  @media screen and (max-width: 375px) {
    .modal-image {
      /* max-width: 100%; */
      height: 300px !important;
    }
  }
  @media screen and (max-width: 320px) {
    .modal-image {
      /* max-width: 100%; */
      height: 250px !important;
    }
  }
`;

export default GalleryPageArea;
